import { render, staticRenderFns } from "./ModuleCard.vue?vue&type=template&id=46f1f2de"
import script from "./ModuleCard.vue?vue&type=script&lang=js"
export * from "./ModuleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports